var map = {
	"./obj_mascot_2_1.png": 83585,
	"./obj_mascot_2_10.png": 64789,
	"./obj_mascot_2_2.png": 34602,
	"./obj_mascot_2_3.png": 73459,
	"./obj_mascot_2_4.png": 89852,
	"./obj_mascot_2_5.png": 19269,
	"./obj_mascot_2_6.png": 31118,
	"./obj_mascot_2_7.png": 74135,
	"./obj_mascot_2_8.png": 23600,
	"./obj_mascot_2_9.png": 20505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40587;